// Revised cycles use authoritative earned pay, never reprice earlier classes.
export const revisedSalary = (cycle, fallback) => cycle?.hasFeeRevision &&
  Number.isFinite(cycle.revisedPerClassSalary) ? cycle.revisedPerClassSalary : fallback;
export const earnedTutorPay = (cycle, fallback) => cycle?.hasFeeRevision
  ? Number(cycle.calculatedAmount || 0) : fallback;
export const projectedTutorPay = (cycle, fallback) => {
  if (!cycle?.hasFeeRevision) return fallback;
  if (["PAID", "APPROVED"].includes(cycle.status)) return Number(cycle.calculatedAmount || 0);
  return Number.isFinite(cycle.projectedTutorCost) ? cycle.projectedTutorCost : Number(cycle.calculatedAmount || 0);
};
export const additionalParentFee = cycle => Number(cycle?.feeRevisionCycle?.additionalFee || 0);
